import React, { memo } from "react";
import Countdown from "react-countdown";
import PropTypes from "prop-types";

const Completionist = () => (
  <span className="otp-css">
    Your OTP has expired. Press <b> &apos;Resend OTP&apos; </b> to get a new code.
  </span>
);

const Renderer = ({ minutes, seconds, completed }) => {
  if (completed) {
    return <Completionist />;
  }
  return (
    <span className="otp-css">
      OTP will expire in {" "}
      <span className='font-weight-bold'>
        ({minutes}:{`0${seconds}`.slice(-2)})
      </span>
    </span>
  );
};

Renderer.defaultProps = {
  minutes: '', seconds: '', completed: false
}

Renderer.propTypes = {
  minutes: PropTypes.string, seconds: PropTypes.string, completed: PropTypes.bool
}

function CountDownComponent({ key }) {
  return (
    <div>
      <Countdown
        key={key}
        date={Date.now() + 60000}
        renderer={Renderer}
      />
    </div>
  );
}
CountDownComponent.defaultProps = {
  key: ''
};

CountDownComponent.propTypes = {
  key: PropTypes.string,
};

export default memo(CountDownComponent);
